"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPatch = ModalPatch;
exports.ReCAPTCHAPatch = ReCAPTCHAPatch;
exports.getHighestZindex = getHighestZindex;
exports.knownZIndexes = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const knownZIndexes = exports.knownZIndexes = {
  tooltip: 2500,
  overlay: 2000,
  dropdown: 1200,
  dropdownNested: 1201,
  anchorLinkNav: 1048,
  secondaryNav: 1049,
  primaryNav: 1050,
  newsletter: 2,
  chatWidgetZIndex: 108000
};
function getHighestZindex() {
  return Math.max(...Object.values(knownZIndexes));
}
function ModalPatch({
  maxKnownZIndex = 0,
  isCentered = false
}) {
  const defaultStyle = `
    .ux-disrupt-backdrop {
      z-index: ${Math.max(maxKnownZIndex, knownZIndexes.secondaryNav) + 1};
    }
    
    .ux-dialog-float {
      float: none !important;
    }

    html[dir="rtl"] .ux-dialog-float > * {
      position: absolute;
      top: 0;
      right: unset;
    }
    
    .ux-dialog-content {
      overflow: inherit;
    }

    span.ux-dialog-float {
      position: absolute;
      top: 0;
      inset-inline-end: 0;
      z-index: 2;
      height: fit-content !important;
    }
  `;
  const centeredStyle = isCentered ? `
      .ux-dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;

        #checkout-cart-express-cart {
          width: 100%;
        }
      }
    ` : '';
  const combinedStyle = `
    ${defaultStyle}
    ${centeredStyle}
  `;
  return /*#__PURE__*/_react.default.createElement("style", null, combinedStyle);
}
ModalPatch.propTypes = {
  maxKnownZIndex: _propTypes.default.number,
  isCentered: _propTypes.default.bool
};

/**
 * this is a bandaid to support recaptcha verification when prompted on a modal layer
 * Investigation underway here: https://jira.godaddy.com/browse/UXP-7505
 * @returns {React.ReactElement} global styles
 */
function ReCAPTCHAPatch() {
  const style = `
    body > div > div > iframe {
      pointer-events: initial;
    }
`;
  return /*#__PURE__*/_react.default.createElement("style", null, style);
}